import { VariantColor } from '@repo/toolkit/colors'
import { DateFormatter } from '@repo/toolkit/date'
import { Link } from 'react-router-dom'

import Badge from '../../atoms/badge'

export const TableLink = ({ to, label }: { to: string; label: string }) => {
  return (
    <Link
      to={to}
      className="text-blue"
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      {label}
    </Link>
  )
}

type TableDateProps = {
  date: Date | string
  variant?: VariantColor
}

export const TableDate = ({ date, variant = 'grey' }: TableDateProps) => {
  return <Badge text={DateFormatter.DDMMYYYY(new Date(date))} variant={variant} />
}

export const TableBoolean = ({ value }: { value: boolean }) => {
  return <Badge text={value ? 'Oui' : 'Non'} variant={value ? 'success' : 'danger'} />
}
